import dayjs from "dayjs";
import ChatBubble from "./ChatBubble";

export interface Message {
    text: string;
    sender: "user" | "admin";
    type: string;
    timestamp: string;
    message_id?: string;
    is_read?: boolean | number;
    is_delivered?: boolean | number;
    _id?: string;
    wa_id?: string;
    status?: string;
    provider_response?: unknown;
    body?: string;
    full_message?: string;
    caption?: string | null;
    media_url?: string | null;
    media_mime_type?: string | null;
    message_type?: string;
    template_name?: string;
    template_language?: string;
    template_variables?: Record<string, unknown>;
    sent_at?: string;
    target_message_id?: string;
    reactions?: Array<{
      emoji: string;
      wa_id?: string;
      reacted_at?: string;
      reaction_message_id?: string;
    }>;
    reply_to_message_id?: string | null;
    reply_to_wa_id?: string | null;
    is_forwarded?: boolean;
    is_frequently_forwarded?: boolean;
    reply_to_message?: Message;
}

interface ChatWindowProps {
  messages: Message[];
  previewImage: string | null;
  setPreviewImage: (url: string | null) => void;
}

const ChatWindow: React.FC<ChatWindowProps> = ({ messages, previewImage, setPreviewImage }) => {
  // Sort messages by timestamp first
  const sortedMessages = [...messages].sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
  
  // Group messages by date (e.g., "18-07-2025")
  const groupedByDate = sortedMessages.reduce<Record<string, Message[]>>((acc, msg) => {
    const dateKey = dayjs(msg.timestamp).format("DD-MM-YYYY");
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(msg);
    return acc;
  }, {});
  const messageById = sortedMessages.reduce<Record<string, Message>>((acc, msg) => {
    const id = msg.message_id || msg._id;
    if (id) acc[id] = msg;
    return acc;
  }, {});

  return (
    <div className="flex flex-col space-y-1 px-1 sm:px-2">
      {Object.entries(groupedByDate)
        .sort(([a], [b]) => dayjs(a, "DD-MM-YYYY").valueOf() - dayjs(b, "DD-MM-YYYY").valueOf())
        .map(([date, msgs]) => (
        <div key={date}>
          <div className="text-xs text-center text-gray-500 dark:text-gray-400 my-2 sm:my-3 bg-white/80 dark:bg-gray-700/80 rounded-full px-3 py-1 mx-auto w-fit">
            {date}
          </div>
          <div className="space-y-1">
            {msgs.map((msg, index) => {
              const uniqueKey = msg.message_id || msg._id || `msg-${index}`;
              const repliedMessage = msg.reply_to_message_id ? msg.reply_to_message : undefined;
              return <ChatBubble key={uniqueKey} msg={msg} repliedMessage={repliedMessage} previewImage={previewImage} setPreviewImage={setPreviewImage} />
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ChatWindow;
